import script from "./MarketRibbon.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarketRibbon.vue?vue&type=script&lang=ts&setup=true"

import "./MarketRibbon.vue?vue&type=style&index=0&id=22c0be60&lang=scss"

const __exports__ = script;

export default __exports__